import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: #000;

  .panel {
    padding: 40px;
    background-color: #fff;
    border-radius: 5px;
    text-align: center;
    max-width: 400px;

    h2 {
      font-size: 28px;
      margin-bottom: 30px;
    }

    .note {
      margin: 20px 0 0 0;
      color: #888;
    }

    .btn-primary {
      background-color: #000;
      border: #000;

      &:active {
        background-color: #313131;
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/admin/components/Auth/styles.js